module.exports = __webpack_public_path__ + "img/icon-10.a0efbc9b.png";